import React from 'react';

interface SelectOption {
  value: string | number; // Allow number for value
  label: string;
}

interface SelectInputProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'onChange'> {
  id: string;
  name: string;
  options: SelectOption[];
  value: string | number; // Allow number for value
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  placeholder?: string;
  className?: string;
  label?: string; // Optional label
}

/**
 * Standard select input component with consistent styling
 */
const SelectInput: React.FC<SelectInputProps> = ({
  id,
  name,
  options,
  value,
  onChange,
  placeholder,
  className = '',
  label, // Destructure label
  ...props
}) => {
  return (
    <div className="w-full">
      {label && <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1">{label}</label>}
      <select
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        className={`block w-full px-3 py-2 border border-primary-silver rounded-md shadow-sm focus:outline-none focus:ring-primary-charcoal focus:border-primary-charcoal sm:text-sm ${className}`}
        {...props}
      >
        {placeholder && (
          <option value="" disabled={value !== ""}> {/* Ensure placeholder is selectable if value is empty */}
            {placeholder}
          </option>
        )}
        {options.map(option => (
          <option key={option.value.toString()} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectInput; 